import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';
import {FilterMatchMode} from 'primevue/api';
import BarcodeRangeFilter from '@/models/dto/filters/BarcodeRangeFilter';

export default function () {
  const pageable = usePageable();

  const filters = ref({
    code: {value: null},
    stakeholder: {value: null, matchMode: FilterMatchMode.EQUALS},
    stakeholderId: {value: null, matchMode: FilterMatchMode.CONTAINS},
    deleted: {value: null, matchMode: FilterMatchMode.EQUALS},
    lineIdFilter: {
      stakeholderId: {value: null, matchMode: FilterMatchMode.EQUALS},
      duplexHigh: {value: null, matchMode: FilterMatchMode.CONTAINS},
      duplexLow: {value: null, matchMode: FilterMatchMode.CONTAINS},
      mainVenue: {value: [], matchMode: FilterMatchMode.CONTAINS},
      licencePeriod: {value: [], matchMode: FilterMatchMode.CONTAINS},
      startDate: {value: null, matchMode: FilterMatchMode.EQUALS},
      endDate: {value: null, matchMode: FilterMatchMode.EQUALS},
    }
  });

  /**
   * Réinitialise les filtres
   */
  function reset() {
    filters.value.stakeholderId.value = null;
    filters.value.stakeholder.value = null;
    filters.value.deleted.value = null;
    filters.value.lineIdFilter.duplexHigh.value = null;
    filters.value.lineIdFilter.duplexLow.value = null;
    filters.value.lineIdFilter.mainVenue.value = [];
    filters.value.lineIdFilter.licencePeriod.value = [];
    filters.value.lineIdFilter.startDate.value = null;
    filters.value.lineIdFilter.endDate.value = null;
    filters.value.code.value = null;
  }

  /**
   * Récupère les paramètres de la requête
   * @return {BarcodeRangeFilter} Les paramètres de la requête
   */
  function getQueryParams() {
    return new BarcodeRangeFilter({
      pageable: pageable.getQueryParams(),
      code: filters.value.code.value,
      stakeholder: filters.value.stakeholder.value,
      stakeholderId: filters.value.stakeholderId.value,
      deleted: filters.value.deleted.value,
      lineIdFilter: {
        stakeholderId: filters.value.lineIdFilter.stakeholderId.value,
        duplexHigh: filters.value.lineIdFilter.duplexHigh.value,
        duplexLow: filters.value.lineIdFilter.duplexLow.value,
        mainVenues: filters.value.lineIdFilter.mainVenue.value,
        licencePeriods: filters.value.lineIdFilter.licencePeriod.value,
        startDate: filters.value.lineIdFilter.startDate.value,
        endDate: filters.value.lineIdFilter.endDate.value,
      },
    });
  }

  return {
    pageable,
    filters,
    reset,
    getQueryParams,
  }
}


